import request from '@/utils/request'

// 获取试卷数据
export function getExamPaper(examId) {
  return request({
    url: `/api/exam/paper/${examId}`,
    method: 'get'
  })
}

// 提交考试答案
export function submitExamAnswers(data) {
  return request({
    url: '/api/exam/submit',
    method: 'post',
    data
  })
}

// 获取考试结果
export function getExamResult(examId) {
  return request({
    url: `/api/exam/result/${examId}`,
    method: 'get'
  })
}

// 获取考试列表
export function getExamList(params) {
  return request({
    url: '/api/exam/list',
    method: 'get',
    params
  })
}

// 用户端查询考试列表
export function getFrontendExamList(params) {
  return request({
    url: '/api/frontend/exam/list',
    method: 'get',
    params
  })
}

// 用户端获取正式考试试卷
export function getFrontendExamPaper(examId) {
  return request({
    url: `/api/frontend/exam/${examId}/exam`,
    method: 'get'
  })
}

// 用户端提交考试
export function submitFrontendExam(data) {
  return request({
    url: '/api/frontend/exam/submit',
    method: 'post',
    data
  })
}

// 用户端获取我的考试列表
export function getMyExamList(params) {
  return request({
    url: '/api/frontend/exam/my-list',
    method: 'get',
    params
  })
}

// 获取倒计时信息
export function getExamCountdown(examId) {
  return request({
    url: `/api/exam/countdown/${examId}`,
    method: 'get'
  })
}

export function getMyExams(params) {
  return request({
    url: '/api/frontend/personal/my-exams',
    method: 'get',
    params
  })
}

export function getMyPapers(params) {
  return request({
    url: '/api/frontend/personal/my-papers',
    method: 'get',
    params
  })
}

export function getPaperAnswerResult(paperId) {
  return request({
    url: '/api/frontend/personal/my-papers/answer-result',
    method: 'get',
    params: { paperId }
  })
}

export function getMyPracticeExams(params) {
  return request({
    url: '/api/frontend/personal/my-practice-exams',
    method: 'get',
    params: { ...(params || {}), exam_type: 2 }
  })
}

export function getMyWrongQuestions(params) {
  return request({
    url: '/api/frontend/personal/my-wrong-questions',
    method: 'get',
    params
  })
}

// 成绩查询
export function getGradeQuery(params) {
  return request({
    url: '/api/frontend/personal/grade-query',
    method: 'get',
    params
  })
}

// 获取学员错题数量统计
export function getWrongQuestionCount() {
  return request({
    url: '/api/frontend/personal/wrong-question-count',
    method: 'get'
  })
}

// 获取学员错题练习抽题配置
export function getWrongQuestionPracticeConfig() {
  return request({
    url: '/api/frontend/personal/wrong-question-practice/config',
    method: 'get'
  })
}

export function markWrongQuestionMastered(id) {
  return request({
    url: `/api/frontend/personal/my-wrong-questions/${id}/mastered`,
    method: 'post'
  })
}

export function deleteWrongQuestion(id) {
  return request({
    url: `/api/frontend/personal/my-wrong-questions/${id}`,
    method: 'delete'
  })
}

// 保存错题练习配置
export function saveWrongQuestionPracticeConfig(data) {
  return request({
    url: '/api/frontend/personal/wrong-question-practice/config',
    method: 'post',
    data
  })
}

// 生成错题练习试卷
export function generateWrongQuestionPractice(data) {
  return request({
    url: '/api/frontend/personal/wrong-question-practice/generate',
    method: 'post',
    data
  })
}

// 提交错题练习
export function submitWrongQuestionPractice(data) {
  return request({
    url: '/api/frontend/personal/wrong-question-practice/submit',
    method: 'post',
    data
  })
}

// 查询试卷列表
export function getPaperList(params) {
  return request({
    url: '/api/frontend/paper/list',
    method: 'get',
    params,
    paramsSerializer: p => {
      const query = p || {}
      return Object.keys(query).map(key => {
        const val = query[key]
        if (val == null || val === '') return ''
        if (Array.isArray(val)) {
          return val.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&')
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
      }).filter(Boolean).join('&')
    }
  })
}

// 获取试卷详情（包含题目）
export function getPaperDetail(id) {
  return request({
    url: `/api/frontend/paper/${id}`,
    method: 'get'
  })
}

// 获取课程试卷预览题目
export function getPaperPractice(id) {
  return request({
    url: `/api/frontend/paper/${id}/practice`,
    method: 'get'
  })
}

export function getPaperQuestion(id) {
  return request({
    url: `/api/frontend/paper/question/${id}`,
    method: 'get'
  })
}

// 根据规则获取练习题目
export function getPracticeQuestions(data) {
  return request({
    url: '/api/frontend/question/practice',
    method: 'post',
    data
  })
}

export function getAdvertisementList(params) {
  return request({
    url: '/api/frontend/advertisement/list',
    method: 'get',
    params
  })
}

export function reportFaceFail(examId, reason) {
  return request({
    url: '/api/frontend/exam/face-fail',
    method: 'post',
    params: { examId, reason }
  })
}
